import { render, staticRenderFns } from "./subscriptionPlan.vue?vue&type=template&id=62b8825c&scoped=true&"
import script from "./subscriptionPlan.vue?vue&type=script&lang=js&"
export * from "./subscriptionPlan.vue?vue&type=script&lang=js&"
import style0 from "./subscriptionPlan.vue?vue&type=style&index=0&id=62b8825c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8825c",
  null
  
)

export default component.exports